import apiService,{ BASE_URL } from "./apiServices";

export const getLastLoginDataServices = async (token, payload, page = 0, size = 5, sort = []) => {
  try {
    const queryParams = new URLSearchParams({ page, size });
    sort.forEach(s => queryParams.append('sort', s));

    const response = await apiService(
      `/user-logs/employee-log?${queryParams.toString()}`,
      'POST',
      payload,
      null,
      token
    );
    return response;
  } catch (error) {
    throw new Error(error?.message || 'Service failed. Please try again.');
  }
};

  export const getExpiredPolicyDataServices = async (token,id) => {
    try {
      const response = await apiService(`/expired-policy/${id}`, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw (error?.message || 'service is failed. Please try again.');
    }
  }

  export const  getRenewalReportDataServices = async (token,id) => {
    try {
      const response = await apiService(`/renewal-report/${id}`, 'GET', null, null, token);
       return response;
    } catch (error) {
      throw (error?.message || 'service is failed. Please try again.');
    }
  }

   export const getReportMissingDocument = async (id, page, size,token ) => {
    try {

      const response = await apiService(`/missing-document/${id}&page=${page}&size=${size}&sort=desc`, 'GET', null, null, token);

      return response;
    } catch (error) {
      throw (error?.message || 'Service failed. Please try again.');
    }
  };

    export const getFilterReportMissingDocument = async (formData, token, page, size) => {

      try {
          const response = await apiService(`/filter/ReportMissingDocument?page=${page}&size=${size}&sort=desc`, 'POST', formData, null, token);
          return response;
      } catch (error) {
          console.error('Error fetching filtered data:', error);
      }
    };

   export const getReportSource = async (id, page, size,token ) => {
    try {

      const response = await apiService(`/report-source/${id}&page=${page}&size=${size}&sort=desc`, 'GET', null, null, token);

      return response;
    } catch (error) {
      throw (error?.message || 'Service failed. Please try again.');
    }
  };

  export const getFilterReportSource = async (formData, token, page, size) => {

      try {
          const response = await apiService(`/filter/ReportSource?page=${page}&size=${size}&sort=desc`, 'POST', formData, null, token);
          return response;
      } catch (error) {
          console.error('Error fetching filtered data:', error);
      }
    };


   export const getReportCarrierName = async (id, page, size,token ) => {
    try {

      const response = await apiService(`/carrier-name/${id}&page=${page}&size=${size}&sort=desc`, 'GET', null, null, token);

      return response;
    } catch (error) {
      throw (error?.message || 'Service failed. Please try again.');
    }
  };

  export const getFilterReportCarrierName = async (formData, token, page, size) => {

      try {
          const response = await apiService(`/filter/ReportCarrier?page=${page}&size=${size}&sort=desc`, 'POST', formData, null, token);
          return response;
      } catch (error) {
          console.error('Error fetching filtered data:', error);
      }
    };

   export const getReportQuoteType = async (id, page, size,token ) => {
    try {

      const response = await apiService(`/quote-type/${id}&page=${page}&size=${size}&sort=desc`, 'GET', null, null, token);

      return response;
    } catch (error) {
      throw (error?.message || 'Service failed. Please try again.');
    }
  };

   export const getFilterReportQuoteType = async (formData, token, page, size) => {

      try {
          const response = await apiService(`/filter/ReportQuoteType?page=${page}&size=${size}&sort=desc`, 'POST', formData, null, token);
          return response;
      } catch (error) {
          console.error('Error fetching filtered data:', error);
      }
    };


  export const getFilterReportZipCode = async (formData, token, page, size) => {

      try {
          const response = await apiService(`/filter/ReportZipCode?page=${page}&size=${size}&sort=desc`, 'POST', formData, null, token);
          return response;
      } catch (error) {
          console.error('Error fetching filtered data:', error);
      }
    };

     export const getReportLocationGroup = async (id, page, size,token ) => {
    try {

      const response = await apiService(`/location-group/${id}&page=${page}&size=${size}&sort=desc`, 'GET', null, null, token);

      return response;
    } catch (error) {
      throw (error?.message || 'Service failed. Please try again.');
    }
  };

    export const getFilterReportLocationGroup = async (formData, token, page, size) => {

      try {
          const response = await apiService(`/filter/ReportLocationGroup?page=${page}&size=${size}&sort=desc`, 'POST', formData, null, token);
          return response;
      } catch (error) {
          console.error('Error fetching filtered data:', error);
      }
    };


  export const getLineOfBusinessDataServices = async (formData,page,size,token) => {
    try {
      const response = await apiService(`/reports/policy/by-line-of-business?page=${page}&size=${size} `, 'POST', formData, null, token);
      return response;
    } catch (error) {
      throw (error?.message || 'service is failed. Please try again.');
    }
  }

   export const  getLeadSourceReportDataServices = async (token,id) => {
    try {
      const response = await apiService(`/lead-source-report/${id}`, 'GET', null, null, token);
       return response;
    } catch (error) {
      throw (error?.message || 'service is failed. Please try again.');
    }
  }

  export const getquoteStatusDataServices = async (token,id) => {
    try {
      const response = await apiService(`/quote-status/${id}`, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw (error?.message || 'service is failed. Please try again.');
    }
  }

   export const  getPendingCancellationDataServices = async (token,id) => {
    try {
      const response = await apiService(`/pending-cancellation/${id}`, 'GET', null, null, token);
       return response;
    } catch (error) {
      throw (error?.message || 'service is failed. Please try again.');
    }
  }

  export const getpolicyReportDataServices = async (formData,page,size,token) => {
    try {
      const response = await apiService(`/reports/policy/by-type?page=${page}&size=${size}`, 'POST', formData, null, token);
      return response;
    } catch (error) {
      throw (error?.message || 'service is failed. Please try again.');
    }
  }


export const getEmployeeSummaryService = async (formData, token, page, size) => {
    try {
        const response = await apiService(`/reports/addtask/task-report?page=${page}&size=${size}`, 'POST', formData, null, token);
        return response;
    } catch (error) {
        throw (error?.message || 'service is failed. Please try again.');
    }
};

  export const getmissingDocumnetsDataServices = async (token,id,page,size) => {
    try {
      const response = await apiService(`/missing-documents/${id}?page=${page}&size=${size}`, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw (error?.message || 'service is failed. Please try again.');
    }
  }

  export const getAllProductionReportService = async (token, page, size, property, sortType) => {
  try {
    const sortParam = property && sortType ? `&sort=${property},${sortType}` : '';
    const response = await apiService(
      `/production-reports/all?page=${page}&size=${size}${sortParam}`,
      'GET',
      null,
      null,
      token
    );
    return response;
  } catch (error) {
    throw (error?.message || 'Service failed. Please try again.');
  }
};
export const getReportZipCode = async (filters, page, size, token) => {
  try {

    const response = await apiService(
      `/rater-report/search?page=${page}&size=${size}`,
      'POST',
      filters,
      null,
      token
    );

    return response;
  } catch (error) {
    throw error?.message || 'Service failed. Please try again.';
  }
};

export const getSearchAllProductionReportService = async (
  formData,
  token,
  page,
  size,
  sortField = "",
  sortOrder = "asc"
) => {
  try {
    let url = `/production-reports/search?page=${page}&size=${size}`;
    if (sortField) {
      url += `&sort=${sortField},${sortOrder}`;
    }
    const response = await apiService(url, 'POST', formData, null, token);
    return response;
  } catch (error) {
    throw (error?.message || 'service is failed. Please try again.');
  }
};


    export const getZipCodeService = async (zipcode,token) => {
    try {
      const response = await apiService(`/locale/search/zip?query=${zipcode}&limit=10`, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw (error?.message || 'service is failed. Please try again.');
    }
  }

export const exportReport = async (filters, format, token, sortField, sortOrder) => {
  try {
    const params = new URLSearchParams();
    params.append("format", format);

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(`${key}`, value === "All" ? "" : value);
      }
    });

    if (sortField && sortOrder) {
      params.append("sort", `${sortField},${sortOrder}`);
    }
const queryString = params.toString().replace(/\+/g, '%20');
    // Direct fetch for better blob handling
    const response = await fetch(`${BASE_URL}/reports/production/export?${queryString}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv',
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Get the blob from response
    const blob = await response.blob();

    if (blob.size === 0) {
      throw new Error('Empty file received from server');
    }

    // Determine MIME type and extension
    let mimeType;
    let fileExtension;

    switch (format.toLowerCase()) {
      case 'pdf':
        mimeType = 'application/pdf';
        fileExtension = 'pdf';
        break;
      case 'xlsx':
      case 'excel':
        mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        fileExtension = 'xlsx';
        break;
      case 'csv':
        mimeType = 'text/csv';
        fileExtension = 'csv';
        break;
      default:
        mimeType = 'application/octet-stream';
        fileExtension = format;
    }

    // Create proper blob with MIME type
    const properBlob = new Blob([blob], { type: mimeType });

    // Download the file
    const url = window.URL.createObjectURL(properBlob);
    const link = document.createElement("a");
    link.href = url;

    const timestamp = new Date().toISOString().slice(0, 19).replace(/[:-]/g, '').replace('T', '_');
    link.setAttribute("download", `production_report_${timestamp}.${fileExtension}`);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error('Export service error:', error);
    throw error?.message || "Export service failed. Please try again.";
  }
};

export const exportLeadReport = async (filters, format, token) => {
  try {
    const params = new URLSearchParams();
    params.append("format", format);

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(`${key}`, value === "All" ? "" : value);
      }
    });

    // if (sortField && sortOrder) {
    //   params.append("sort", `${sortField},${sortOrder}`);
    // }
const queryString = params.toString().replace(/\+/g, '%20');
    // Direct fetch for better blob handling
    const response = await fetch(`${BASE_URL}/reports/lead/export?${queryString}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv',
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Get the blob from response
    const blob = await response.blob();

    if (blob.size === 0) {
      throw new Error('Empty file received from server');
    }

    // Determine MIME type and extension
    let mimeType;
    let fileExtension;

    switch (format.toLowerCase()) {
      case 'pdf':
        mimeType = 'application/pdf';
        fileExtension = 'pdf';
        break;
      case 'xlsx':
      case 'excel':
        mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        fileExtension = 'xlsx';
        break;
      case 'csv':
        mimeType = 'text/csv';
        fileExtension = 'csv';
        break;
      default:
        mimeType = 'application/octet-stream';
        fileExtension = format;
    }

    // Create proper blob with MIME type
    const properBlob = new Blob([blob], { type: mimeType });

    // Download the file
    const url = window.URL.createObjectURL(properBlob);
    const link = document.createElement("a");
    link.href = url;

    const timestamp = new Date().toISOString().slice(0, 19).replace(/[:-]/g, '').replace('T', '_');
    link.setAttribute("download", `lead_report_${timestamp}.${fileExtension}`);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error('Export service error:', error);
    throw error?.message || "Export service failed. Please try again.";
  }
};

export const exportEmployeeLogReportService = async (filters, format, token) => {
  try {
    const params = new URLSearchParams();
    params.append("format", format);

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(`${key}`, value === "All" ? "" : value);
      }
    });

    // if (sortField && sortOrder) {
    //   params.append("sort", `${sortField},${sortOrder}`);
    // }
const queryString = params.toString().replace(/\+/g, '%20');
    // Direct fetch for better blob handling
    const response = await fetch(`${BASE_URL}/reports/user-logs/export?${queryString}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv',
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Get the blob from response
    const blob = await response.blob();

    if (blob.size === 0) {
      throw new Error('Empty file received from server');
    }

    // Determine MIME type and extension
    let mimeType;
    let fileExtension;

    switch (format.toLowerCase()) {
      case 'pdf':
        mimeType = 'application/pdf';
        fileExtension = 'pdf';
        break;
      case 'xlsx':
      case 'excel':
        mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        fileExtension = 'xlsx';
        break;
      case 'csv':
        mimeType = 'text/csv';
        fileExtension = 'csv';
        break;
      default:
        mimeType = 'application/octet-stream';
        fileExtension = format;
    }

    // Create proper blob with MIME type
    const properBlob = new Blob([blob], { type: mimeType });

    // Download the file
    const url = window.URL.createObjectURL(properBlob);
    const link = document.createElement("a");
    link.href = url;

    const timestamp = new Date().toISOString().slice(0, 19).replace(/[:-]/g, '').replace('T', '_');
    link.setAttribute("download", `Employee_log_report_${timestamp}.${fileExtension}`);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error('Export service error:', error);
    throw error?.message || "Export service failed. Please try again.";
  }
};
export const exportTaskReportService = async (filters, format, token) => {
  try {
    const params = new URLSearchParams();
    params.append("format", format);

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(`${key}`, value === "All" ? "" : value);
      }
    });

    // if (sortField && sortOrder) {
    //   params.append("sort", `${sortField},${sortOrder}`);
    // }
const queryString = params.toString().replace(/\+/g, '%20');
    // Direct fetch for better blob handling
    const response = await fetch(`${BASE_URL}/reports/task/export?${queryString}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv',
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Get the blob from response
    const blob = await response.blob();

    if (blob.size === 0) {
      throw new Error('Empty file received from server');
    }

    // Determine MIME type and extension
    let mimeType;
    let fileExtension;

    switch (format.toLowerCase()) {
      case 'pdf':
        mimeType = 'application/pdf';
        fileExtension = 'pdf';
        break;
      case 'xlsx':
      case 'excel':
        mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        fileExtension = 'xlsx';
        break;
      case 'csv':
        mimeType = 'text/csv';
        fileExtension = 'csv';
        break;
      default:
        mimeType = 'application/octet-stream';
        fileExtension = format;
    }

    // Create proper blob with MIME type
    const properBlob = new Blob([blob], { type: mimeType });

    // Download the file
    const url = window.URL.createObjectURL(properBlob);
    const link = document.createElement("a");
    link.href = url;

    const timestamp = new Date().toISOString().slice(0, 19).replace(/[:-]/g, '').replace('T', '_');
    link.setAttribute("download", `Task_report_${timestamp}.${fileExtension}`);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error('Export service error:', error);
    throw error?.message || "Export service failed. Please try again.";
  }
};

export const exportRaterReportService = async (filters, format, token) => {
  try {
    const params = new URLSearchParams();
    params.append("format", format);

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(`${key}`, value === "All" ? "" : value);
      }
    });

    // if (sortField && sortOrder) {
    //   params.append("sort", `${sortField},${sortOrder}`);
    // }
const queryString = params.toString().replace(/\+/g, '%20');
    // Direct fetch for better blob handling
    const response = await fetch(`${BASE_URL}/reports/rater/export?${queryString}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv',
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Get the blob from response
    const blob = await response.blob();

    if (blob.size === 0) {
      throw new Error('Empty file received from server');
    }

    // Determine MIME type and extension
    let mimeType;
    let fileExtension;

    switch (format.toLowerCase()) {
      case 'pdf':
        mimeType = 'application/pdf';
        fileExtension = 'pdf';
        break;
      case 'xlsx':
      case 'excel':
        mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        fileExtension = 'xlsx';
        break;
      case 'csv':
        mimeType = 'text/csv';
        fileExtension = 'csv';
        break;
      default:
        mimeType = 'application/octet-stream';
        fileExtension = format;
    }

    // Create proper blob with MIME type
    const properBlob = new Blob([blob], { type: mimeType });

    // Download the file
    const url = window.URL.createObjectURL(properBlob);
    const link = document.createElement("a");
    link.href = url;

    const timestamp = new Date().toISOString().slice(0, 19).replace(/[:-]/g, '').replace('T', '_');
    link.setAttribute("download", `rater_report_${timestamp}.${fileExtension}`);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error('Export service error:', error);
    throw error?.message || "Export service failed. Please try again.";
  }
};